import './navigation';
import './header';
import './ajax-add-to-cart';
import './quantity';
import './single-post';

document.querySelectorAll('.CategoryNav__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
        const sublist = btn.closest('.CategoryNav__item').querySelector('.CategoryNav__sublist');
        const isOpen = !sublist.classList.contains('CategoryNav__sublist--hidden');

        sublist.classList.toggle('CategoryNav__sublist--hidden', isOpen);
        btn.classList.toggle('CategoryNav__toggle--open', !isOpen);
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
});